import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LegalPage from "../pages/legal/LegalPage";
import NosotrosPage from "../pages/nosotros/page";
import ServiciosPage from "../pages/servicios/page";
import OpinionesPage from "../pages/opiniones/page";
import SucursalesPage from "../pages/sucursales/page";
import GaleriaPage from "../pages/galeria/page";
import ContactoPage from "../pages/contacto/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/nosotros", element: <NosotrosPage /> },
  { path: "/servicios", element: <ServiciosPage /> },
  { path: "/opiniones", element: <OpinionesPage /> },
  { path: "/sucursales", element: <SucursalesPage /> },
  { path: "/galeria", element: <GaleriaPage /> },
  { path: "/contacto", element: <ContactoPage /> },
  { path: "/legal/:tipo", element: <LegalPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
